import { type DocumentNode, gql } from '@apollo/client';

const createViewFieldMutation: DocumentNode = gql`
  mutation create_view_field(
    $viewId: ID!
    $fieldDefId: ID!
    $fieldType: String
    $fieldLabel: String
    $sequence: Int
    $autoSequence: Boolean
  ) {
    createViewField(
      viewId: $viewId
      fieldDefId: $fieldDefId
      fieldType: $fieldType
      fieldLabel: $fieldLabel
      sequence: $sequence
      autoSequence: $autoSequence
    ) {
      viewField {
        id
        view {
          id
        }
        sequence
        fieldLabel
      }
    }
  }
`;

export default createViewFieldMutation;
